'use client'

import { EnhancedCarousel } from './enhanced-carousel'
import { ProductCard } from './product-card'

interface Product {
  id: string
  name: string
  slug: string
  description?: string
  price: number
  stock: number // ✅ ADD
  category?: string
  imageUrl?: string | null
  images: Array<{
    id: string
    url: string
    alt?: string | null
  }>
}

interface FeaturedProductsCarouselProps {
  products: Product[]
}

export function FeaturedProductsCarousel({
  products,
}: FeaturedProductsCarouselProps) {
  return (
    <EnhancedCarousel
      itemsPerView={{ mobile: 1.2, tablet: 2.5, desktop: 4 }}
      showArrows={true}
      showDots={false}
      autoPlay={true}
      autoPlayInterval={5000}
      className='my-8 md:my-12'
    >
      {products.map(product => (
        <ProductCard key={product.id} product={product} />
      ))}
    </EnhancedCarousel>
  )
}
